import { Button as AntdButton } from 'antd';
import styled from 'styled-components';

const Button = styled(AntdButton)`
    &.ant-btn {
        height: 30px;
        border-radius: 2px;
        font-size: var(--button-font-size, 14px);
        padding: 4px 15px;
    }
`;

export default Button;
